import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AppService} from "../../core/services/app.service";

@Injectable({
    providedIn: 'root'
})

export class PointService {
    constructor(public http: HttpClient) {
    }
    
    
    public static eventPointRankingAPI = AppService.getApiUrl() + '/api/UserEventPointRankings/';
    public static eventPointAPI = AppService.getApiUrl() + '/api/UserEventPoints';

    getEventPoint(eventId, customerId) {
        let url = PointService.eventPointRankingAPI + `?filter[where][eventId]=${eventId}`;
        
        if (customerId) {
            url = url +  `&filter[where][customerId]=${customerId}`
        }
        return this.http.get(url);
    }
    
    addEventPoint(data) {
        return this.http.post(PointService.eventPointAPI + '/addPoint', data);
    }
}
